import { createSlice } from '@reduxjs/toolkit';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { ReportHistoryState } from './types/reportHistoryState';
import { getAdministrators, getPeriodForReportHistory, getReportHistory } from './reportHistoryThunks';
import { getAdministratorOptions, getMonthOptions } from '../../common/utils';

const initialState: ReportHistoryState = {
  loadingReportHistory: null,
  loadingPeriodsForReportHistory: ThunkRequestStatus.Pending,
  reportHistory: [],
  reportingPeriodOptions: [],
  error: '',
  administratorOptions: [],
  loadingAdministrators: ThunkRequestStatus.Pending,
};

const reportHistorySlice = createSlice({
  initialState,
  name: 'reportHistory',
  reducers: {
    resetReportHistory() {
      return initialState;
    },
  },
  extraReducers: builder => {
    // Get report history
    builder.addCase(getReportHistory.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingReportHistory = ThunkRequestStatus.Fulfilled;
        state.reportHistory = action.payload;
      }
    });
    builder.addCase(getReportHistory.pending, state => {
      state.loadingReportHistory = ThunkRequestStatus.Pending;
    });
    builder.addCase(getReportHistory.rejected, state => {
      state.loadingReportHistory = ThunkRequestStatus.Rejected;
    });

    //Get period for report history
    builder.addCase(getPeriodForReportHistory.fulfilled, (state, action) => {
      if (action.payload) {
        state.reportingPeriodOptions = getMonthOptions(action.payload);
        state.loadingPeriodsForReportHistory = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getPeriodForReportHistory.pending, state => {
      state.loadingPeriodsForReportHistory = ThunkRequestStatus.Pending;
    });
    builder.addCase(getPeriodForReportHistory.rejected, state => {
      state.loadingPeriodsForReportHistory = ThunkRequestStatus.Rejected;
    });

    //Get administrators
    builder.addCase(getAdministrators.fulfilled, (state, action) => {
      if (action.payload) {
        state.administratorOptions = getAdministratorOptions(action.payload);
        state.loadingAdministrators = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getAdministrators.pending, state => {
      state.loadingAdministrators = ThunkRequestStatus.Pending;
    });
    builder.addCase(getAdministrators.rejected, state => {
      state.loadingAdministrators = ThunkRequestStatus.Rejected;
    });
  },
});

export const { resetReportHistory } = reportHistorySlice.actions;

export const reportHistoryReducer = reportHistorySlice.reducer;
